import { useMutation } from 'react-query';

import { deleteComment } from 'services/messages';

export default function useDeleteComment() {
  const mutation = useMutation({
    mutationFn: deleteComment,
  });

  return mutation;
}
